import { yup } from '@core/middlewares'
import {
    ID_NUMBER_LENGTH,
    TAX_NUMBER_LENGTH,
} from './InvoiceInfoCreate.constants'

export const invoiceInfoCreateValidationSchema = yup.object().shape({
    title: yup.string().required().min(2),
    customer_type: yup.string().oneOf(['personal', 'corporate']).required(),
    first_name: yup.string().required(),
    last_name: yup.string().required(),
    phone: yup.string().required(),
    email: yup.string().email(),
    id_number: yup.string().when('customer_type', {
        is: 'personal',
        then: schema => schema.required().length(ID_NUMBER_LENGTH),
        otherwise: schema => schema.notRequired(),
    }),
    company_name: yup.string().when('customer_type', {
        is: 'corporate',
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    tax_office: yup.string().when('customer_type', {
        is: 'corporate',
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    tax_number: yup.string().when('customer_type', {
        is: 'corporate',
        then: schema => schema.required().length(TAX_NUMBER_LENGTH),
        otherwise: schema => schema.notRequired(),
    }),
    address: yup.array().of(yup.number().required()).length(3).required(),
    street: yup.string(),
    building_number: yup.string(),
    floor: yup.string(),
    door_number: yup.string(),
})
